import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Unit } from '@app/shared/models/unit';
import { FormatValuePipeOptions, FormatValuePipe } from '@app/shared/pipes/format-value.pipe';
import { NgxMaskPipe } from 'ngx-mask';

@Component({
    selector: 'app-rendered-value',
    templateUrl: './rendered-value.component.html',
    styleUrls: ['./rendered-value.component.scss'],
    imports: [
        FormatValuePipe,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        NgxMaskPipe,
    ],
})
export class RenderedValueComponent implements OnChanges {

    @Input({ required: true }) value!: string | number | null;

    @Input({ required: true }) unit!: Unit | null;

    @Input() customPrecision?: number;

    @Input() evaluated: boolean | null = true;

    protected formatValueOptions: Partial<FormatValuePipeOptions> = {};

    ngOnChanges(changes: SimpleChanges) {
        if ('customPrecision' in changes || 'evaluated' in changes) {
            this.formatValueOptions = {
                customPrecision: this.customPrecision,
                evaluated: this.evaluated,
            };
        }
    }
}
